import { CreateContractRequestBody, RegistrationResponseBody } from '@boltenergy-be/shared'
import { NextApiResponseBody } from 'types/bolt-api/request'

export const createContract = async (body: CreateContractRequestBody): Promise<NextApiResponseBody<RegistrationResponseBody>> => {
  try {
    const res = await fetch(`/api/registrations/contracts`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody<RegistrationResponseBody>
  } catch (error) {
    return {
      success: false,
      message: error?.message || 'createContract request failed'
    }
  }
}
